<!--{{ 'language' | language:'start':languageService.selectedLanguage }}-->
<ng-container *ngIf="true;
then notSignedIn">
</ng-container>

<ng-template #notSignedIn>
  <div class="example-container" [class.example-is-mobile]="mobileQuery.matches" style="background: black;">

    <mat-sidenav-container class="example-sidenav-container" autosize
                           [style.marginTop.px]="mobileQuery.matches ? 0 : 0" style="flex: initial">


      <nav class="navbar navbar-expand-lg noselect" [ngClass]="{'navbar-light': !toggleControl.value,
      'navbar-dark': toggleControl.value, 'bg-light': !toggleControl.value, 'bg-dark': toggleControl.value}"
           style="background-color: var(--second-background) !important; max-width: 1600px; margin: auto; border-bottom: 1px solid gray; margin-bottom: 20px;">
        <a class="navbar-brand" routerLink="/"><img style="margin: 30px 0;"
                                                    [style.height.px]="mobileQuery.matches ? 30 : 44"
                                                    [src]="'./assets/' + (!toggleControl.value ? 'sibrica-logo-color.png' : 'sibrica-logo-middle.png')"
                                                    alt=""></a>
        <div class="language-container-mobile" style="display: flex; flex-direction: row; align-items: center; gap: 12px;">
          <div style="display:flex; flex-direction: row; gap: 6px; margin-left: 12px;">
            <div class="language" [ngClass]="{'chosen-language': languageService.selectedLanguage === 'pl'}"
                 (click)="changeLang('pl'); cookie_info();">PL
            </div>
            <div>|</div>
            <div class="language" [ngClass]="{'chosen-language': languageService.selectedLanguage === 'en'}"
                 (click)="changeLang('en'); cookie_info();">EN
            </div>
            <div>|</div>
            <div class="language" [ngClass]="{'chosen-language': languageService.selectedLanguage === 'de'}"
                 (click)="changeLang('de'); cookie_info();">DE
            </div>
          </div>
          <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarText"
                  aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>

        <div class="collapse navbar-collapse" id="navbarText">
          <div class="navbar-nav mr-auto">
            <center class="nav-item" routerLinkActive="active-list-item" routerLink="/"
                    [routerLinkActiveOptions]="{exact:true}">
              <a class="nav-link">{{ 'toolbar main page' | language:'app':languageService.selectedLanguage }}</a>
            </center>
            <center class="nav-item" routerLinkActive="active-list-item" routerLink="/o-nas">
              <a class="nav-link">{{ 'toolbar about us' | language:'app':languageService.selectedLanguage }}</a>
            </center>
            <center class="nav-item" routerLinkActive="active-list-item" routerLink="/kontakt">
              <a class="nav-link">{{ 'toolbar contact' | language:'app':languageService.selectedLanguage }}</a>
            </center>
          </div>
          <div class="navbar-text" style="display: flex; flex-direction: column; align-items: flex-end">
            <!--            <a style="color: var(&#45;&#45;text); font-weight: 600;" href="#">Kontakt</a>-->
            <div
              style="display: flex; flex-wrap: wrap; flex-direction: row; justify-content: flex-end; align-items: center">
              <div></div>
              <a class="phone"
                 style="display: flex; flex-direction: row; justify-content:center; align-items: center; color: var(--text); border-radius: 5px; padding: 6px 12px;"
                 [href]="'tel:'+ config.contact_phone.replace(' ', '').replace(' ', '').replace(' ', '')">
                <div style="height: 24px;" [title]="config.contact_phone">
                  <mat-icon class="contact-icon" style="margin-right: 6px;">phone</mat-icon>
                </div>
                <div style="white-space: nowrap; padding:0" class="nav-link">
                  {{config.contact_phone}}
                </div>
              </a>
              <button
                style="border: 0; background: transparent; display: flex; flex-direction: row; justify-content: center; align-items: center"
                (click)="$event.stopPropagation(); toggleControl.setValue(!toggleControl.value)">
                <mat-icon style="cursor: pointer; color: var(--text)">wb_sunny</mat-icon>
                <mat-slide-toggle style="margin-right: 8px; margin-left: 8px;"
                                  (keydown.enter)="toggleControl.setValue(!toggleControl.value)"
                                  [formControl]="toggleControl"
                                  class="ngmodel-without-validation"
                                  (click)="toggleControl.setValue(!toggleControl.value)"></mat-slide-toggle>
                <mat-icon style="cursor: pointer; color: var(--text)">bedtime</mat-icon>
              </button>
              <div class="language-container" style="display:flex; flex-direction: row; gap: 6px; margin-left: 12px;">
                <div class="language" [ngClass]="{'chosen-language': languageService.selectedLanguage === 'pl'}"
                     (click)="changeLang('pl'); cookie_info();">PL
                </div>
                <div>|</div>
                <div class="language" [ngClass]="{'chosen-language': languageService.selectedLanguage === 'en'}"
                     (click)="changeLang('en'); cookie_info();">EN
                </div>
                <div>|</div>
                <div class="language" [ngClass]="{'chosen-language': languageService.selectedLanguage === 'de'}"
                     (click)="changeLang('de'); cookie_info();">DE
                </div>
              </div>
            </div>

          </div>
        </div>
      </nav>

      <!--      <mat-toolbar style="background-color: var(&#45;&#45;second-background); max-width: 1600px; margin:auto"-->
      <!--                   class="example-toolbar" [style.height.px]="mobileQuery.matches ? 120 : 160">-->
      <!--        <div routerLink="/" style="padding: 0 0 0 6px"><img [style.height.px]="mobileQuery.matches ? 30 : 44"-->
      <!--                                                            src="./assets/logo-pronotes-short-color.png" alt=""><span-->
      <!--          [style.font-size.px]="mobileQuery.matches ? 16 : 20" style="letter-spacing: 2px;"></span></div>-->
      <!--        <div class="flex-stretch"></div>-->
      <!--        <a style="color: var(&#45;&#45;text); font-weight: 600; margin-right: 12px;" href="#">Kontakt</a>-->
      <!--        <a-->
      <!--          style="display: flex; flex-direction: row; justify-content:center; align-items: center; color: var(&#45;&#45;text); opacity: 0.5; border-radius: 5px; padding: 6px 12px; margin-right: 12px;"-->
      <!--          [href]="'tel:'+ config.contact_phone.replace(' ', '').replace(' ', '').replace(' ', '')">-->
      <!--          <div style="height: 24px;" [title]="config.contact_phone">-->
      <!--            <mat-icon class="contact-icon" style="margin-right: 6px;">phone</mat-icon>-->
      <!--          </div>-->
      <!--          <div>{{config.contact_phone}}-->
      <!--          </div>-->
      <!--        </a>-->

      <!--        <button-->
      <!--          style="border: 0; background: transparent; display: flex; flex-direction: row; justify-content: center; align-items: center"-->
      <!--          (click)="$event.stopPropagation(); toggleControl.setValue(!toggleControl.value)">-->
      <!--          <mat-icon style="cursor: pointer; color: var(&#45;&#45;text)">wb_sunny</mat-icon>-->
      <!--          <mat-slide-toggle style="margin-right: 8px; margin-left: 8px;"-->
      <!--                            (keydown.enter)="toggleControl.setValue(!toggleControl.value)" [formControl]="toggleControl"-->
      <!--                            class="ngmodel-without-validation"-->
      <!--                            (click)="toggleControl.setValue(!toggleControl.value)"></mat-slide-toggle>-->
      <!--          <mat-icon style="cursor: pointer; color: var(&#45;&#45;text)">bedtime</mat-icon>-->
      <!--        </button>-->


      <!--      </mat-toolbar>-->


      <div style="max-width: 1600px; margin:auto">
        <router-outlet *ngIf="!(router.url.includes('/sign-in'))"></router-outlet>
      </div>

      <div class="footer-accent"></div>
      <div class="site-footer" style="padding: 40px 0 20px; color: white;">
        <div style="max-width: 1600px; margin: auto;">
          <div class="row" style="--bs-gutter-x: 0;">

            <div class="col-sm-6 col-xl-3 noselect"
                 style="display:flex; flex-direction: column; align-items: center; justify-content: center; margin-bottom: 30px;">
              <a routerLink="/"><img [style.height.px]="mobileQuery.matches ? 60 : 70"
                                     src="./assets/sibrica-logo-white.png" alt=""></a>
            </div>

            <div class="col-sm-6 col-xl-3 footer-items">
              <div class="footer-item">
                <div><b>Sibrica</b></div>
                <a class="contact contact-email" routerLink="/big-data">
                  <div>{{ 'footer big data' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/hurtownie-danych">
                  <div>{{ 'footer data warehouses' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/optymalizacja-systemow">
                  <div>{{ 'footer systems optimization' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/bezpieczenstwo">
                  <div>{{ 'footer security' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/rozwiazania-duzej-dostepnosci">
                  <div>{{ 'footer high availability solutions' | language:'app':languageService.selectedLanguage }}</div>
                </a>
              </div>
            </div>

            <div class="col-sm-6 col-xl-3 footer-items">
              <div class="footer-item">
                <div><b>{{ 'footer information' | language:'app':languageService.selectedLanguage }}</b></div>
                <a class="contact contact-email" routerLink="/o-nas">
                  <div>{{ 'footer about us' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/">
                  <div>{{ 'footer our offer' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/kontakt">
                  <div>{{ 'footer contact' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/warunki">
                  <div>{{ 'footer terms of use' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/polityka">
                  <div>{{ 'footer privacy policy' | language:'app':languageService.selectedLanguage }}</div>
                </a>
                <a class="contact contact-email" routerLink="/rodo">
                  <div>{{ 'footer rodo' | language:'app':languageService.selectedLanguage }}</div>
                </a>
              </div>
            </div>

            <div class="col-sm-6 col-xl-3 footer-items">
              <div class="footer-item">
                <div><b>{{ 'footer contact us' | language:'app':languageService.selectedLanguage }}</b></div>
                <div>
                  <a class="contact"
                     [href]="'tel:'+ config.contact_phone.replace(' ', '').replace(' ', '').replace(' ', '')">
                    <div style="height: 24px;" [title]="config.contact_phone">
                      <mat-icon class="contact-icon" style="margin-right: 6px;">phone</mat-icon>
                    </div>
                    <div class="contact-phone">{{config.contact_phone}}</div>
                  </a>
                  <div style="font-size: 14px; margin-left: 30px;">
                    <div style="display: flex; justify-content: space-between;">
                      <div style="opacity: 0.6;">{{ 'footer monday to friday' | language:'app':languageService.selectedLanguage }}</div>
                      <div style="opacity: 0.9; font-weight: 600; margin-left: 6px;">10:00 - 18:00</div>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                      <div style="opacity: 0.6;">{{ 'footer saturday to sunday' | language:'app':languageService.selectedLanguage }}</div>
                      <div style="opacity: 0.9; font-weight: 600; margin-left: 12px;">{{ 'footer inactive' | language:'app':languageService.selectedLanguage }}</div>
                    </div>
                  </div>
                </div>
                <a class="contact" [href]="'mailto:'+ config.contact_email">
                  <div style="height: 24px;" [title]="config.contact_email">
                    <mat-icon class="contact-icon" style="margin-right: 6px;">email</mat-icon>
                  </div>
                  <div class="contact-email">{{config.contact_email}}</div>
                </a>
              </div>
            </div>
          </div>

          <div class="noselect">
            <center style="font-size: 14px; opacity: 0.5; margin: auto;">Sibrica © 2012-{{currentYear}} {{ 'footer all rights reserved' | language:'app':languageService.selectedLanguage }}
            </center>
          </div>

        </div>
      </div>


      <!--      <app-sign-in *ngIf="router.url.includes('/sign-in')" (signed)="foo($event)"></app-sign-in>-->
      <!--      <app-start *ngIf="router.url.includes(('/start'))" (started)="foo2($event)"></app-start>-->

      <section class="cookie-banner" *ngIf="showCookieBanner" aria-label="Ustawienia cookies">
        <h3>{{ 'cookies banner title' | language:'app':languageService.selectedLanguage }}</h3>
        <p>{{ 'cookies banner text' | language:'app':languageService.selectedLanguage }}</p>
        <div class="cookie-banner-actions">
          <button type="button" class="cookie-accept" (click)="acceptCookies()">
            {{ 'cookies accept' | language:'app':languageService.selectedLanguage }}
          </button>
          <button type="button" class="cookie-reject" (click)="rejectCookies()">
            {{ 'cookies reject' | language:'app':languageService.selectedLanguage }}
          </button>
        </div>
      </section>

      <button type="button" class="cookie-manage" *ngIf="showCookieManageButton" (click)="openCookieSettings()">
        {{ 'cookies manage' | language:'app':languageService.selectedLanguage }}
      </button>
    </mat-sidenav-container>
  </div>
</ng-template>



